import React, { useEffect, useState } from 'react'
import Nav from './Nav'
import { NavLink } from 'react-router-dom'
import FaqSection from './FaqSection'
import Testimonials from "./Testimonials"
import "./Home.css"
function Home() {
    const [header,setHeader]=useState(0)

  useEffect(()=>{
    const interval=setInterval(()=>{
      setHeader(prevCount=>(prevCount+1)%3)
    },5000)
return ()=>{clearInterval(interval)}
  },[])

const dynamicHeader=()=>{
  if(header===0){
    return "first"
  }else if(header===1){
    return "second"

  }else if(header===2){
    return "third"
  }else if(header===3){
    return "fourth"

  }else{
    return "fifth"

  }
}

const dynamicBanner=()=>{
   if(header===0){
    return "banner-first"
  }else if(header===1){
    return "banner-second"

  }else if(header===2){
    return "banner-third"
  }else {
    return "banner-fourth"

}}

  return (
    <>

        <header className={`header ${dynamicHeader()}`}>
      
      <div class={`section__container header__container `} id="home">
        <h1> <span class="morara">Morara Home</span> Furniture<br/>
        </h1>
        <h2>We specialize in classic household and office furniture, blending timeless elegance with unique designs to suit every lifestyle and workspace</h2>
          <NavLink className="btn btn__secondary" id='btn-link' to="/products">
         View Furnitures
          <span><i class="ri-arrow-right-double-line"></i></span>
          </NavLink>

      </div>
    </header>

<br/>
<br id="about" />

   <section class="about" >
  <div class="section__container about__container">
    <div class="about__grid">
      <div class="about__content">
        <p class="section__subheader" >About Us</p>
        <h2 class="section__header">Our Story</h2>
        <p class="para">
          At Morara Homes Furniture, we are your trusted partner in creating
          timeless living spaces. With years of dedication to craftsmanship,
          we have become a leading name in quality furniture, committed to
          blending elegance, comfort, and durability in every piece we make.
          Your home’s beauty is our passion.
        </p>
        <br />
        <p class="para">
          We uphold the highest standards of design and integrity, ensuring
          that every client receives furniture that not only lasts but also
          transforms their space into a warm and stylish environment.
        </p>
      </div>
      <div class="about__list">
        <div class="about__item">
          <span><i class="fa-solid fa-house"></i></span>
          <h4>Turning houses into homes</h4>
        </div>
        <div class="about__item">
          <span><i class="fa-solid fa-chair"></i></span>
          <h4>Crafting comfort with style</h4>
        </div>
        <div class="about__item">
          <span><i class="fa-solid fa-couch"></i></span>
          <h4>Furniture designed for every lifestyle</h4>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="stats" id="stats">
  <div class="section__container stats__container">
    <div class="stats__content">
      <p class="section__subheader">Morara Homes</p>
      <h2 class="section__header">Our Stats</h2>
      <p class="para">
        With a team of skilled craftsmen and designers, we bring passion,
        creativity, and expertise into every piece of furniture we create. 
        Our commitment to quality and style has earned us the trust of 
        countless homeowners, helping transform ordinary spaces into 
        timeless living experiences.
      </p>
      <div class="stats__grid">
        <div class="stats__card">
          <span><i class="ri-thumb-up-fill"></i></span>
          <h4>1800+</h4>
          <p>Happy Clients</p>
        </div>
        <div class="stats__card">
          <span><i class="ri-user-fill"></i></span>
          <h4>120+</h4>
          <p>Skilled Artisans</p>
        </div>
        <div class="stats__card">
          <span><i class="ri-user-smile-line"></i></span>
          <h4>950+</h4>
          <p>Homes Furnished</p>
        </div>
        <div class="stats__card">
          <span><i class="ri-trophy-fill"></i></span>
          <h4>25+</h4>
          <p>Awards Won</p>
        </div>
      </div>
    </div>
    <div class="stats__image">
      <img src="https://images.unsplash.com/photo-1653972233971-8d7852fb815d?q=80&w=1032&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="living room furniture" />
      <img src="https://images.unsplash.com/photo-1680503397667-3877494708a1?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="modern sofa set" />
    </div>
  </div>
</section>

<section class={`banner ${dynamicBanner()}`}>
  <div class="section__container banner__container">
    <div class="banner__content">
      <p class="section__subheader">More Info</p>
      <h2 class="section__header">
        We Believe In Creating Timeless Comfort For Every Home
      </h2>
      <p class="para">
        At Morara Homes Furniture, we combine expert craftsmanship with
        thoughtful design to deliver furniture that truly transforms your
        living spaces. Whether for your home or office, our collections bring
        together style, durability, and comfort — built with you in mind.
      </p>
      <div class="banner__btns">
      <NavLink to="/contact">
       <span class="btn btn__secondary" href='#about' id='btn-link'>
          Contact Now
          <span><i class="ri-arrow-right-double-line"></i></span>
        </span></NavLink>
       
       <NavLink to="/quote">
       <span class="btn btn__secondary get-quote" href='#about' id='btn-link'>
          Get a Quote
          <span><i class="ri-arrow-right-double-line"></i></span>
        </span></NavLink>
      </div>
    </div>
  </div>
</section>

<section class="blog" id="blog">
  <div class="section__container blog__container">
    <p class="section__subheader">Our Posts</p>
    <h2 class="section__header">Blog Posts</h2>
    <div class="blog__grid">
      <div class="blog__card">
        <img src="https://images.unsplash.com/photo-1605774337664-7a846e9cdf17?q=80&w=774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="blog" />
        <div>
          <span><i class="ri-user-line"></i> By David</span>
          <span><i class="ri-time-line"></i> Jun 28, 2022</span>
          <span><i class="ri-thumb-up-line"></i> 5</span>
        </div>
        <h4>Sustainable Furniture Design</h4>
        <p>
          Learn how eco-friendly materials and processes are shaping the
          future of modern furniture.
        </p>
      </div>
      <div class="blog__card">
        <img src="https://images.unsplash.com/photo-1722604834579-e004fd776280?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="blog" />
        <div>
          <span><i class="ri-user-line"></i> By Sarah</span>
          <span><i class="ri-time-line"></i> Nov 22, 2022</span>
          <span><i class="ri-thumb-up-line"></i> 18</span>
        </div>
        <h4>Styling Small Spaces</h4>
        <p>
          Discover smart tips for making the most out of small living areas
          with functional and stylish furniture.
        </p>
      </div>
      <div class="blog__card">
        <img src="https://images.unsplash.com/photo-1540574163026-643ea20ade25?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="blog" />
        <div>
          <span><i class="ri-user-line"></i> By Michael</span>
          <span><i class="ri-time-line"></i> Mar 15, 2023</span>
          <span><i class="ri-thumb-up-line"></i> 20</span>
        </div>
        <h4>Modern Living Trends</h4>
        <p>
          Explore the latest furniture and interior trends that bring comfort
          and style into every home.
        </p>
      </div>
    </div>
  </div>
</section>

  <Testimonials/>

    
            </>
  )
}

export default Home
